/*eslint-disable*/ import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Box from '@mui/material/Box';

// @mui/icons-material
import FormatAlignLeft from "@mui/icons-material/FormatAlignLeft";
import Favorite from "@mui/icons-material/Favorite";
// core components
import Header from "components/Header/HeaderTribalism.js";
import HeaderLinks from "components/Header/HeaderLinksTribalism.js";
import Parallax from "components/Parallax/Parallax.js";
import Footer from "components/Footer/TribalismFooter.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
// sections for this page
import SectionText from "pages-sections/blog-post/2016/10/attribution-and-military-tactics-in-digital-marketing/SectionText.js";
import SectionBlogInfo from "pages-sections/blog-post/2016/10/attribution-and-military-tactics-in-digital-marketing/SectionBlogInfo.js";
import SectionComments from "pages-sections/blog-post/SectionComments.js";
import SectionSimilarStories from "pages-sections/blog-post/2016/10/attribution-and-military-tactics-in-digital-marketing/SectionSimilarStories.js";
import styles from "../../../../pages-sections/services/ServicesSections.module.scss";






export const metadata = {
  title: "Measure Camp 2016 - Attribution, Military Tactics, Digital Marketing - Tribalism",
  date: "2016-10-21",
  summary: "We are an Australian Data Analytics and Digital Marketing Agency based in Melbourne. This blog is about our experience at Measure Camp 2016!",
  image: "/img/posts/2016-10-21-attribution-and-military-tactics-in-digital-marketing/1.webp",
  url: "https://www.tribalism.com.au/blog-post/2016/10/attribution-and-military-tactics-in-digital-marketing",
  author: "Scott Sunderland",
};


export default function BlogPostPage() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });
  const classes = styles;
  return (
    <div>
      <Header
        brand="http://localhost:3000/img/clients/TribalismLogoRev.webp" 
        links={<HeaderLinks dropdownHoverColor="info" />}
        fixed
        title="Measure Camp 2016 - Attribution, Military Tactics, Digital Marketing - Tribalism"
        image="/img/posts/2016-10-21-attribution-and-military-tactics-in-digital-marketing/1.webp"
        url="https://www.tribalism.com.au/blog-post/2016/10/attribution-and-military-tactics-in-digital-marketing"
        type="article"
        description="We are an Australian Data Analytics and Digital Marketing Agency based in Melbourne. This blog is about our experience at Measure Camp 2016!"

        color="transparent"
        changeColorOnScroll={{
          height: 300,
          color: "info",
        }}
      />
      <Parallax image="/img/posts/2016-10-21-attribution-and-military-tactics-in-digital-marketing/1.webp" filter="dark" small>
        <div className={classes.container}>
          <GridContainer justifyContent="center">
            <GridItem md={8} className={classes.textCenter}>
              <Box 
                sx={{
                  '& H1': {
                    fontSize: {
                      xs: '2rem',
                      sm: '2.5rem',
                      md: '2.6rem',
                      lg: '3.5rem',
                      xl: '5rem'
                    }
                  }
                }}
              >
                <h1 className={classes.title}>
                  Measurecamp 2016 - Attribution And Military Tactics In Digital Marketing.
                </h1>
              </Box>
              <br />
              <Button color="rose" size="lg" href="#start" round>
                <FormatAlignLeft /> Read Article
              </Button>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classes.main}>
        <div className={classes.container}>
          <SectionText />
          <SectionBlogInfo />
          <SectionComments />
        </div>
      </div>

      <Footer
        
      />
    </div>
  );
}
